<nav aria-label="breadcrumb" class="w-full mb-4 sm:mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center px-1 gap-2 sm:gap-0"
  *ngIf="breadcrumbs$ | async as breadcrumbs">
  <ol class="flex flex-wrap items-center py-2" *ngIf="breadcrumbs.length > 0">
    <!-- Home Link -->
    <li
      class="flex cursor-pointer items-center text-xs sm:text-sm text-slate-500 transition-colors duration-300 hover:text-slate-700">
      <a routerLink="/admin" aria-label="Accueil">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-4 sm:size-5" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
        </svg>
      </a>
    </li>

    <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <li class="flex items-center text-slate-500">
        <span class="mx-1 sm:mx-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-3 sm:size-4" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </span>
      </li>
      <li class="flex cursor-pointer items-center text-xs sm:text-sm transition-colors duration-300 hover:text-slate-700"
        [class.font-bold]="last"
        [class.text-slate-800]="last"
        [class.text-slate-500]="!last"
        [attr.aria-current]="last ? 'page' : null">
        <a [routerLink]="breadcrumb.url" *ngIf="!last; else lastBreadcrumb">
          {{ breadcrumb.label }}
        </a>
        <ng-template #lastBreadcrumb>
          <span>{{ breadcrumb.label }}</span>
        </ng-template>
      </li>
    </ng-container>
  </ol>

  <ng-container *ngTemplateOutlet="rightContent$ | async"></ng-container>
</nav>